import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';

type Props = Omit<TextFieldProps, 'onChange' | 'value'> & {
  /** Controlled value of the search input. */
  value: string;
  /** Called when the user types or clears the search. */
  onSearch: (value: string) => void;
  /** Optional callback when the clear button is clicked (before onSearch is called with ''). */
  onClear?: () => void;
};

/**
 * Fully controlled search input with search icon and clear button.
 * Use when the value is owned by the parent (e.g. from URL params or global state).
 */
export function ControlledSearchBox(props: Props) {
  const { value, onSearch, onClear, placeholder, ...rest } = props;

  function handleClear() {
    onClear?.();
    onSearch('');
  }

  return (
    <TextField
      size="small"
      value={value}
      onChange={(evt) => onSearch(evt.target.value)}
      placeholder={placeholder ?? ''}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton size="small" onClick={handleClear} data-cy="searchbox-clear" edge="end">
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
      {...rest}
    />
  );
}
